export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30')
];

export const server_loads = [0];

export const dictionary = {
		"/": [~3],
		"/about": [~4],
		"/admin": [5],
		"/admin/rss": [6],
		"/api/youtube/pubsub/test": [7],
		"/articles": [~8],
		"/asmr": [~9],
		"/calendar": [~10],
		"/category/[id]": [~11],
		"/channel-rankings": [~13],
		"/channels": [~14],
		"/channel/[id]": [~12],
		"/daily-articles": [~15],
		"/daily-articles/[slug]": [~16],
		"/follow": [~17],
		"/group-rankings": [~19],
		"/group/[id]": [~18],
		"/live-rankings": [~20],
		"/maintenance": [21],
		"/multiview": [~22],
		"/mypage": [23,[],[2]],
		"/privacy": [24],
		"/profile-card": [25],
		"/rankings": [26],
		"/schedule": [~27],
		"/search": [~28],
		"/terms": [29],
		"/video/[id]": [~30]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),

	reroute: (() => {})
};

export { default as root } from '../root.svelte';